import { getHondaExpApiHeaders, getHondaExpApiUrl } from '@honda-canada/js-utilities/lib/hondaExpApi';
import { useMemo } from 'react';
import { useLanguage } from '../../../utils/sitecoreContext';
import { useGetDealerAvailabilityQuery } from '../../apis/dealerApi';
import useSotHondaExpApiConfig from '../../../utils/sitecoreContext/useSotHondaExpApiConfig';
var ProductLineCode;
(function (ProductLineCode) {
    ProductLineCode["ACURA"] = "A";
    ProductLineCode["ENGINE"] = "E";
    ProductLineCode["HONDA"] = "H";
    ProductLineCode["MC"] = "M";
    ProductLineCode["PE"] = "P";
    ProductLineCode["MARINE"] = "R";
    ProductLineCode["SXS"] = "S";
    ProductLineCode["ATV"] = "V";
})(ProductLineCode || (ProductLineCode = {}));
var HONDA_EXPERIENCE_API_PRODUCTION_ENV = ['prod', 'production'];
var HONDA_EXPERIENCE_API_UAT = 'uat';
var useFetchDealerAvailability = function (modelCode, dealerCodes) {
    var language = useLanguage();
    var config = useSotHondaExpApiConfig();
    var env = config.env, consumerName = config.consumerName, inventoryConsumerId = config.inventoryConsumerId, inventoryConsumerName = config.inventoryConsumerName;
    var url = useMemo(function () {
        var hondaExpApiUrl = getHondaExpApiUrl({
            /* TODO: PE inventory API currently only available in UAT for NPE,
            to be removed once deployed to all lower env */
            env: HONDA_EXPERIENCE_API_PRODUCTION_ENV.includes(env) ? env : HONDA_EXPERIENCE_API_UAT,
            consumerName: consumerName,
        });
        var baseUrl = "".concat(hondaExpApiUrl, "/inventory");
        var searchParams = new URLSearchParams({
            productLine: ProductLineCode.PE,
            modelCode: modelCode,
            dealerCodes: (dealerCodes || []),
        });
        searchParams.sort();
        return "".concat(baseUrl, "?").concat(searchParams.toString());
    }, [env, consumerName, dealerCodes, modelCode]);
    var headers = getHondaExpApiHeaders({
        // For PE, override with inventory config
        consumerId: inventoryConsumerId !== null && inventoryConsumerId !== void 0 ? inventoryConsumerId : '',
        consumerName: inventoryConsumerName !== null && inventoryConsumerName !== void 0 ? inventoryConsumerName : '',
        language: language,
    });
    var _a = useGetDealerAvailabilityQuery({
        url: url,
        headers: headers,
    }, {
        skip: !(dealerCodes === null || dealerCodes === void 0 ? void 0 : dealerCodes.length),
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, error = _a.error;
    return { hasError: error, isFetching: isFetching, isLoading: isLoading, data: data };
};
export default useFetchDealerAvailability;
